import type { ReactNode } from 'react';
import { Text } from '@savvy-kit/foundations/text';
import { cn } from '@savvy-kit/lib/utils';
import { isNil } from 'es-toolkit';

type PortalCardProps = {
  readonly children: ReactNode;
  readonly title?: string;
  readonly action?: ReactNode;
  readonly padded?: boolean;
  readonly className?: string;
};

export function PortalCard({ children, title, action, padded, className }: PortalCardProps) {
  const hasHeader = !isNil(title);
  const isPadded = padded ?? !hasHeader;

  return (
    <div className={cn('overflow-hidden rounded-xl border border-border-light bg-card', isPadded && 'p-6', className)}>
      {hasHeader && (
        <div className="flex items-center justify-between gap-4 px-6 pb-3 pt-5">
          <Text variant="h4" color="dark">
            {title}
          </Text>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

type PortalCardFooterProps = {
  readonly children: ReactNode;
  readonly className?: string;
};

export function PortalCardFooter({ children, className }: PortalCardFooterProps) {
  return <div className={cn('border-t border-border-light px-6 py-2', className)}>{children}</div>;
}
